import CurrentPromotionsPageBanner from './CurrentPromotionsPageBanner';

export default CurrentPromotionsPageBanner;
